import React from 'react';
import './App.css';
import './components/search-bar.js';
import FormDesigner from './components/FormDesigner';
import Logon from './components/Logon';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { useSelector } from 'react-redux';

function App() {
  const loggedon = useSelector((state) => state.auth.loggedon);

  if (!loggedon) {
    return (
      <>
        <Logon />
        <ToastContainer />
      </>
    );
  }

  return (
    <div className="App">
      <FormDesigner />
      <ToastContainer />
    </div>
  );
}

export default App;
